import styled from 'styled-components';
import { device, doublePadding, ScreenSize } from '@/styles/helpers';

export const ScVipPage = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1088px;
  width: 100%;
  margin: 0 auto;

  & > *:nth-child(n+3) {
    margin-top: 64px;
  }

  @media (${device.desktop}) {
    max-width: ${ScreenSize.DESKTOP + doublePadding}px;
  }

  @media (${device.tablet}) {
    padding: 0 64px;
  }

  @media (${device.mobile}) {
    padding: 0 32px;
  }

  @media (${device.mobileS}) {
    padding: 0 16px;
  }
`;
